import Vue from 'vue'
import vuex from 'vuex'
import axios from 'axios'
Vue.use(vuex);


const state = {
  httpUrl: (() => {
    let hn = window.location.hostname.split('.');
    if (hn.indexOf('test') >= 0 || hn.indexOf('127') >= 0 || hn.indexOf('localhost') >= 0|| hn.indexOf('10') >= 0|| hn.indexOf('tanyan') >= 0) {
      // return "http://127.0.0.1:9999";
      return "http://gateway.zhenyuanma.com";//20210204 zym.so换成zhenyuanma.com
    }
    else {
      return "http://gateway.zhenyuanma.com";//20210204 zym.so换成zhenyuanma.com
    }
  })(),
}

//getter
const getters = {
  httpUrl: state => state.httpUrl,
}

//mutations
const mutations = {
  // changeCurrent(state) {
  //   state.current = localStorage.getItem('current')
  // },
}

const actions = {
  // getPlatform: (context) => {
  //   context.commit('changeCurrent');
  // },

}
export default new vuex.Store({
  state,
  getters,
  mutations,
  actions
})



// WEBPACK FOOTER //
// ./src/store/store.js